export default __webpack_public_path__ + "static/media/powerPylonPale.575d2fc5.svg";